import axiosInstance from "./api";

export const llmModels = {
  gemini_1_5_pro: {
    id: "gemini-1.5-pro",
    name: "Gemini 1.5 Pro",
    description:
      "Gemini 1.5 Pro is a powerful language model trained on a diverse range of internet text.",
  },
  gemini_2_0_flash: {
    id: "gemini-2.0-flash",
    name: "Gemini 2.0 Flash",
    description:
      "Gemini 2.0 Flash is a smaller version of Gemini 1.5 Pro, trained on a diverse range of internet text.",
  },
  gpt_4o: {
    id: "gpt-4o",
    name: "GPT-4o",
    description:
      "GPT-4o is a powerful language model trained on a diverse range of internet text.",
  },
  gpt_4o_mini: {
    id: "gpt-4o-mini",
    name: "GPT-4o Mini",
    description:
      "GPT-4o Mini is a smaller version of GPT-4o, trained on a diverse range of internet text.",
  },
};

export const getChatCompletion = async ({
  messages,
  model = null,
  max_tokens = 100,
  stop = null,
  stream = false,
  temperature = 0,
  response_format = "text",
  variables = null,
  tools = null,
}) => {
  if (!messages?.length || !messages.every((m) => m.role && m.content)) {
    throw new Error("Invalid messages provided");
  }
  if (typeof max_tokens !== "number" || max_tokens < 100) {
    throw new Error("Invalid max tokens provided");
  }
  if (!["text", "json_object"].includes(response_format)) {
    throw new Error(
      'Invalid response type provided, must be "text" or "json_object"'
    );
  }
  if (
    stop &&
    (!Array.isArray(stop) || !stop.every((s) => typeof s === "string"))
  ) {
    throw new Error("Invalid stop provided");
  }
  if (typeof temperature !== "number" || temperature < 0 || temperature > 1) {
    throw new Error("Invalid temperature provided");
  }
  const request = {
    messages,
    model: model || "gemini-1.5-pro", // "gpt-4o",
    max_tokens,
    response_format: { type: response_format },
    stop: stop || [],
    stream,
    temperature,
  };
  if (variables) {
    request.variables = variables;
  }
  if (tools) {
    request.tools = tools;
  }
  const { data } = await axiosInstance.post("/api/chat/completions", request);
  return data;
};
